import React from 'react';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';
import PopoverTrigger from '../Popover';

const AddressField = ({ input, meta }) => (
  <>
    <label
      htmlFor={input.name}
      className={
        meta.touched && meta.error ? 'label form-error__label' : 'label'
      }
    >
      <span>Venue address</span>
      <PopoverTrigger
        styleClass="text-dark py-0 px-1 popover-trigger"
        content="For events that take place in more than one city, and require both be listed on the proof of insurance, please contact us after purchase to customize your certificate."
      />
    </label>
    {meta.touched && meta.error && (
      <div className="form-error">{meta.error}</div>
    )}
    <div className="label__subtext">
      Use the actual location of the event and not a mailing address or post
      office (P.O.) box.
    </div>
    <input
      {...input}
      id={input.name}
      className="form-control form-control-lg"
      placeholder="Address"
      aria-label="Address"
      type="text"
    />
  </>
);
AddressField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default AddressField;
